import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { additionalPropsContext, GroupFilteredType, AttributeType, useCustomizationParams } from '../../context/ViewerContext';
import { instanceOfViewerGroupAttribute, ViewerGroupInterface } from '../../core';

type propsType = {
  groups: ViewerGroupInterface[];
};
export const useAdditionalProps = (props: propsType) => {
  const [t] = useTranslation();
  const { customizationParams } = useCustomizationParams();
  const { groups } = props;
  const { additionalProps, setAdditionalProps } = additionalPropsContext();
  let filters: string[] = customizationParams?.additional_properties_filter || [];

  const addAttributesToAdditionalProps = useCallback(() => {
    if (!groups.length) return;
    let attributes: Record<string, AttributeType> = {};
    let attributesDefLang: Record<string, AttributeType> = {};
    let groupsFiltered: Record<string, GroupFilteredType> = {};
    let groupsFilteredDefLang: Record<string, GroupFilteredType> = {};
    groups.forEach((group) => {
      if (instanceOfViewerGroupAttribute(group)) {
        if (group.attributes && group.attributes.length > 0) {
          const groupId = group.id;
          const attsIds = group.attributes.map((atts) => atts.id);

          groupsFiltered[groupId] = attsIds;
          const groupName = t(groupId);
          //@ts-ignore;
          groupsFiltered[groupId]?.push(groupName);

          groupsFilteredDefLang[groupId] = attsIds;
          const groupNameDefLang = t(groupId, { lng: customizationParams?.defaultLang ?? 'en' });
          //@ts-ignore;
          groupsFilteredDefLang[groupId]?.push(groupNameDefLang);
        }

        group.attributes.forEach((attr) => {
          const key = attr.id;
          const opt = attr.options.find((opt) => opt.selected);

          if (!filters.length) {
            if (opt) {
              attributes[key] = {
                value: t(key),
                option: {
                  value: t(opt.id),
                  code: opt.id,
                },
              };

              attributesDefLang[key] = {
                value: t(key, { lng: 'en' }),
                option: {
                  value: t(opt.id, { lng: 'en' }),
                  code: opt.id,
                },
              };
            }
            return;
          }

          if (filters.length && !filters.includes(key)) return;

          if (opt) {
            attributes[key] = {
              value: t(key),
              option: {
                value: t(opt.id),
                code: opt.id,
              },
            };

            attributesDefLang[key] = {
              value: t(key),
              option: {
                value: t(opt.id),
                code: opt.id,
              },
            };
          }
        });
      }
    });
    setAdditionalProps({
      ...additionalProps,
      attributes: attributes,
      groups: groupsFiltered,
      defaultLang: {
        groups: groupsFilteredDefLang,
        attributes: attributesDefLang,
      },
    });
    console.log('additionalProps: ', additionalProps);
  }, [groups]);

  // If you dont need modelCode and nome of the product just remove the useEffect
  useEffect(() => {
    function initAdditionalProps(event: MessageEvent<any>) {
      if (event.data.type === 'load') {
        const parameters = event.data.parameters;
        setAdditionalProps({
          ...additionalProps,
          modelCode: parameters?.modelCode,
          name: parameters?.name,
        });
      }
    }
    window.addEventListener('message', (event) => initAdditionalProps(event));
    return () => {
      window.removeEventListener('message', (event) => initAdditionalProps(event));
    };
  }, []);

  return {
    addAttributesToAdditionalProps,
  };
};
